// Defines the landing route for each restricted role.

import type { RoleName } from '@/stores/permissions.store';

export const DEFAULT_LANDING_PATH = '/';

/** Client review dashboard — the only page a Client Restricted User can reach. */
export const CLIENT_REVIEW_PATH = '/sentinel-conversations';

/** Agent workspace — a Sentinel user's home, opening on the brand picker. */
export const SENTINEL_WORKSPACE_PATH = '/sentinel-workspace';

const ROLE_LANDING_PATH: Partial<Record<RoleName, string>> = {
	client_restricted: CLIENT_REVIEW_PATH,
	sentinel: SENTINEL_WORKSPACE_PATH
};

/** The path this role should be sent to in place of the home dashboard. */
export function getLandingPath(role: RoleName | null | undefined): string {
	if (!role) return DEFAULT_LANDING_PATH;
	return ROLE_LANDING_PATH[role] ?? DEFAULT_LANDING_PATH;
}

/** True when the role is scoped to one dashboard rather than the whole app. */
export function hasDedicatedLanding(role: RoleName | null | undefined): boolean {
	return getLandingPath(role) !== DEFAULT_LANDING_PATH;
}
